module.exports = __webpack_public_path__ + "static/media/purchase-order-form_2021 USD_price.d5ec66d4.pdf";